/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1204
 */

module.exports = {
  formGroup: "style_formGroup__2buGx",
  formItemWrapper: "style_formItemWrapper__36qsm",
  main: "style_main__-Mk94",
  label: "style_label__3nbW6",
  nowrap: "style_nowrap__26f5I",
  justifyInputContent: "style_justifyInputContent__5NreA",
  justifyContentStart: "style_justifyContentStart__2mg7w",
  radioWrapper: "style_radioWrapper__2zgmk",
  colorBlock: "style_colorBlock__3JwJs",
  slash: "style_slash__1AKIn",
  sizeInputBox: "style_sizeInputBox__1MUeh",
  sizeInputNumberBox: "style_sizeInputNumberBox__99nP4",
  typeSelector: "style_typeSelector__2syDh",
  changeSizeFormItemWrapper: "style_changeSizeFormItemWrapper__DCCWK",
  sizeRadioBox: "style_sizeRadioBox__2QYKu",
  formWidgetTitle: "style_formWidgetTitle__1Hru-",
  formWidgetTitleWithDisableOrVisible: "style_formWidgetTitleWithDisableOrVisible__38j5u",
  btnIcon: "style_btnIcon__3ImYL",
  "coco-iconfont": "style_coco-iconfont__28LJ1",
  formInputNumberRow: "style_formInputNumberRow__12FiK",
  formTitle: "style_formTitle__HF0tp",
  textInput: "style_textInput__rL-3s",
  space: "style_space__1N5on",
  optionSwitch: "style_optionSwitch__33J5U",
  option: "style_option__b8pm8",
  activeOption: "style_activeOption__n6ryr",
  dialog: "style_dialog__1VKxx",
  dialogContent: "style_dialogContent__2CR2t",
  titleWrapper: "style_titleWrapper__6r55C",
  title: "style_title__1ILEq",
  textWrapper: "style_textWrapper__Gd2zh",
  line: "style_line__1L95i",
  firstLine: "style_firstLine__1odOT",
  secondLine: "style_secondLine__2W5Bp",
  buttonWrapper: "style_buttonWrapper__hQDPj",
  button: "style_button__T6Z0H",
  secondary: "style_secondary__3JXHq",
  primary: "style_primary__23umr",
  textButtonWrapper: "style_textButtonWrapper__1pF0K",
  fontFamilyWrapper: "style_fontFamilyWrapper__3S6ef",
  image: "style_image__2cZVb",
  downloadIcon: "style_downloadIcon__3q8t0",
  iconBox: "style_iconBox__1TCF1",
  selectedIcon: "style_selectedIcon__39QAI",
  disabled: "style_disabled__kjomI",
  selected: "style_selected__3aKf0",
  numberSlider: "style_numberSlider__2c2Ho"
}
